const tiComponentEnum = Object.freeze({
  ANALYZE: 'Analyze',
  REMOVE: 'Remove',
  EDIT: 'Edit',
  IMAGE_NAME: 'Image Name:',
  IMAGE_DATE: 'Image Date:',
  MANAGE: 'Manage Images',
  THERMAL_IMAGING: 'Thermal Imaging',
});

export default tiComponentEnum;
